import { observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button, Form, Grid, Header, Icon, Table, Select, Input } from "semantic-ui-react";
import { AlertMessage, DateInput, Text } from "../../../components/common";
import { CurrencyInput } from "../../../components/common/input";
import { NoPermissionMessage } from "../../../components/permission";
import { currency } from "../../../utils/format-helper";
import { hasPermission } from "../../../utils/render-by-permission";
import { IDebtCollectionSueModel } from "../DebtCollectionModel";

interface IDebtCollectionSueCalculator2 extends WithTranslation {
  debtSue: IDebtCollectionSueModel;
}

@observer
class DebtCollectionSueCalculator2 extends React.Component<
  IDebtCollectionSueCalculator2
> {
  state = {
    listData: [],
    total: {
      interestStart: "",
      interestEnd: "",
      dayCal: 0,
      paidEach: 0,
      principle: 0,
      interest: 0,
      principleRemain: 0
    },
    interestStartDate: "",
    paidStartDate: "",
    principleVal: 0,
    interestRate: 0,
    paidEach: 0
  }

  componentDidMount(): void {
    const { debtSue } = this.props;
    this.setState({ interestStartDate: debtSue.judgementInterestStartDate });
    this.setState({ principleVal: debtSue.judgementBalance });
    this.setState({ interestRate: debtSue.judgementInterestRate });

  }


  public render() {
    const { t, debtSue } = this.props;
    return (
      <Form>
        <Header
          size="medium"
          content={
            t(
              "การคำนวณดอกเบี้ยกรณีทำสัญญาประนีประนอมความ (ผ่อนชำระ)"
            )
          }
          subheader={
            t(
              ""
            )
          } />
        <Form.Group widths="equal">
          <Form.Field
            label={t("วันที่เริ่มคิดดอกเบี้ย")}
            control={DateInput}
            value={this.state.interestStartDate}
            fieldName="interestStartDate"
            id={"interestStartDate"}
            onChangeInputField={this.onChangeInterestStartDate}
          />
          <Form.Field
            label={t("วันที่ชำระงวดแรก")}
            control={DateInput}
            value={this.state.paidStartDate}
            fieldName="paidStartDate"
            id={"paidStartDate"}
            onChangeInputField={this.onChangePaidStartDate}
          />
          <Form.Field
            id="form-select-interval"
            control={Input}
            label={t("เงินต้น")}
            value={currency(this.state.principleVal)}
            onChange={(e: any, val: any) => { this.setState({ principleVal: Number(val.value.replace(/,/g, "")) }) }}
          />
          <Form.Field
            id="form-select-interval"
            control={Input}
            label={t("อัตราดอกเบี้ย (%)")}
            value={this.state.interestRate}
            onChange={(e: any, val: any) => { this.setState({ interestRate: val.value }) }}
          />
          <Form.Field
            id="form-select-interval"
            control={Input}
            label={t("จำนวนเงินที่ต้องชำระต่องวด")}
            value={currency(this.state.paidEach)}
            onChange={(e: any, val: any) => { this.setState({ paidEach: Number(val.value.replace(/,/g, "")) }) }}
          />
          <Button
            style={{ whiteSpace: 'nowrap', width: '77px', height: '36px', marginTop: '25px', padding: '10px' }}
            onClick={this.renderResult}
            color="blue"
          >คำนวณ</Button>
        </Form.Group>
        {this.renderTable()}
      </Form>
    );
  }


  public renderTable() {
    return (
      <React.Fragment>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>งวดที่</Table.HeaderCell>
              <Table.HeaderCell>วันที่เริ่มคิดดอกเบี้ย</Table.HeaderCell>
              <Table.HeaderCell>วันที่กำหนดชำระ</Table.HeaderCell>
              <Table.HeaderCell>จำนวนวัน</Table.HeaderCell>
              <Table.HeaderCell>จ่ายเดือนละ</Table.HeaderCell>
              <Table.HeaderCell>เงินกู้ต้นงวด</Table.HeaderCell>
              <Table.HeaderCell>ดอกเบี้ย</Table.HeaderCell>
              <Table.HeaderCell>เงินต้น</Table.HeaderCell>
              <Table.HeaderCell>เงินกู้คงเหลือ</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.state.listData.map((dat: any, i) => {
              const isZero = dat.principleRemain === 0
              return (
                <Table.Row>
                  <Table.Cell>{i + 1}</Table.Cell>
                  <Table.Cell>{dat.interestStart}</Table.Cell>
                  <Table.Cell>{dat.interestEnd}</Table.Cell>
                  <Table.Cell>{dat.dayCal}</Table.Cell>
                  <Table.Cell>{currency(dat.paidEach, 2)}</Table.Cell>
                  <Table.Cell>{currency(dat.principle, 2)}</Table.Cell>
                  <Table.Cell>{currency(dat.interest, 2)}</Table.Cell>
                  <Table.Cell>{currency(dat.paidEachRemain, 2)}</Table.Cell>
                  {isZero ? <Table.Cell>-</Table.Cell> : <Table.Cell>{currency(dat.principleRemain, 2)}</Table.Cell>}
                </Table.Row>
              )
            })}
            {this.state.listData.map((dat: any, i) => {
              const isLastItem = i === this.state.listData.length - 1;
              return (
                <Table.Row key={i}>
                  {isLastItem ? (<Table.Cell></Table.Cell>) : null}
                  {isLastItem ? (<Table.Cell></Table.Cell>) : null}
                  {isLastItem ? (<Table.Cell></Table.Cell>) : null}
                  {isLastItem ? (<Table.Cell></Table.Cell>) : null}
                  {isLastItem ? (<Table.Cell>{currency(dat.sumPaid, 2)}</Table.Cell>) : null}
                  {isLastItem ? (<Table.Cell></Table.Cell>) : null}
                  {isLastItem ? (<Table.Cell>{currency(dat.sumInterest, 2)}</Table.Cell>) : null}
                  {isLastItem ? (<Table.Cell>{currency(dat.sumPrinciple, 2)}</Table.Cell>) : null}
                  {isLastItem ? (<Table.Cell></Table.Cell>) : null}
                </Table.Row>

              )
            })}
          </Table.Body>
        </Table>
      </React.Fragment>
    )
  }

  private onChangeInterestStartDate = (f: any, val: any) => { this.setState({ interestStartDate: val }) }
  private onChangePaidStartDate = (f: any, val: any) => { this.setState({ paidStartDate: val }) }

  public getOptions = (val: number) => {
    let ret = [];
    for (let i = 1; i <= val; i++) {
      let d = { key: i, value: i, text: i };
      ret.push(d);
    }
    return ret;
  }

  public onCalClick() {

  }

  public renderResult = async () => {
    console.log(this.state)
    const { t, debtSue } = this.props;
    let recs = [];
    //let totalAmount = debtSue.judgementBalance +     
    const submitDate = new Date(debtSue.submitDate);
    const lastDate = new Date(debtSue.submitDate);
    let curDate = new Date(debtSue.submitDate);
    let dat: any = {};

    let principle = this.state.principleVal;
    let paidEach = this.state.paidEach;
    let startCalDate = new Date(this.state.interestStartDate);
    let firstPaidDate = new Date(this.state.paidStartDate);
    let dayDiff = 0;
    let interestVal = 0;
    let i: number;
    let sumPaid: number = 0;
    let sumInterest: number = 0;
    let sumRemain: number = 0;

    for (i = 1; i <= 12; i++) {
      if (i == 1) {
        startCalDate = new Date(this.state.interestStartDate);
        firstPaidDate = new Date(this.state.paidStartDate);
        //startCalDate.setDate(firstPaidDate.getDate() + 1);
      }
      dayDiff = this.dateDiff(firstPaidDate, startCalDate);
      interestVal = this.calInterest(this.state.interestRate, dayDiff, principle);
      dat.interestStart = this.printThaiDate(startCalDate);
      dat.interestEnd = this.printThaiDate(firstPaidDate);
      dat.dayCal = dayDiff;
      dat.paidEach = this.state.paidEach;
      dat.principle = principle;
      dat.interest = interestVal;
      dat.paidEachRemain = paidEach - interestVal;
      dat.principleRemain = principle - dat.paidEachRemain;

      // check final
      if ((dat.principle + dat.interest) < this.state.paidEach) {
        dat.paidEach = dat.principle + dat.interest
        dat.paidEachRemain = dat.paidEach - interestVal;
        dat.principleRemain = dat.principle - dat.paidEachRemain;
      }
      console.log(dat);
      sumPaid = sumPaid + dat.paidEach;
      sumInterest = sumInterest + dat.interest;
      sumRemain = sumRemain + dat.paidEachRemain;

      dat.sumPaid = sumPaid;
      dat.sumInterest = sumInterest;
      dat.sumPrinciple = sumRemain;

      recs.push(dat);
      principle = dat.principleRemain;
      if (principle <= 0) {
        break;
      };
      console.log(dat)
      dat = {};
      // after cal
      //startCalDate.setDate(firstPaidDate.getDate() + 1);
      // let tmpDate = this.toNextMonth(firstPaidDate);
      let tmpDate = new Date(firstPaidDate.getFullYear(), firstPaidDate.getMonth(), firstPaidDate.getDate());
      //firstPaidDate.setDate(tmpDate.getDate());
      startCalDate = new Date(tmpDate.getTime() + (24 * 60 * 60 * 1000));
      //startCalDate = new Date(firstPaidDate.getFullYear(), firstPaidDate.getMonth(), firstPaidDate.getDay() + 1);
      firstPaidDate = new Date(firstPaidDate.getFullYear(), firstPaidDate.getMonth() + 1, 5);



    }
    this.setState({ listData: recs });
    return;

  }


  public toNextMonth(d: Date) {
    if (d.getDay() > 5) {

    } else {
      d.setMonth(d.getMonth() + 1);
    }
    let mon = new Date(d.getFullYear() + "-" + d.getMonth().toString().padStart(2, '0') + '-05');
    return mon;
  }

  public dateDiff(d1: Date, d2: Date) {
    return (d1.getTime() - d2.getTime()) / (1000 * 3600 * 24) + 1;
  }

  public calInterest(rate: number, days: number, principle: number): number {
    const interest = principle * (rate / 100) * (days / 365);
    return Number(interest.toFixed(2))
  }

  public printThaiDate(d: Date) {
    return d.toLocaleDateString("th-TH", { year: 'numeric', month: 'long', day: 'numeric' });
  }

}



export default withTranslation()(DebtCollectionSueCalculator2);